module.exports = __webpack_public_path__ + "static/media/AC.d42086b6.png";